import type { FC } from 'react';
import type { ProdutoDetalhado } from '../../../hooks/useProdutosCampanha';
import { ModalOfferTable } from '../../ModalOfferTable';
import styles from '../OfferCreationForm.module.scss';

interface ProductsTableSectionProps {
  data: ProdutoDetalhado[];
  idsLojas: string[];
  sortColumn: string;
  sortType: 'asc' | 'desc';
  onSortColumn: (column: string, type: 'asc' | 'desc') => void;
  onRemoveProduct: (product: ProdutoDetalhado) => void;
}

export const ProductsTableSection: FC<ProductsTableSectionProps> = ({ data, idsLojas, sortColumn, sortType, onSortColumn, onRemoveProduct }) => (
  <section className={`${styles.section} ${styles.table}`}>
    <ModalOfferTable
      data={data as any}
      idsLojas={idsLojas}
      sortColumn={sortColumn}
      sortType={sortType}
      onSortColumn={onSortColumn}
      onRemoveProduct={onRemoveProduct}
    />
  </section>
);

ProductsTableSection.displayName = 'ProductsTableSection';
